var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.errors ? _c('div', _vm._l(_vm.errors, function (v, k) {
    return _c('div', {
      key: k
    }, _vm._l(v, function (error) {
      return _c('p', {
        key: error
      }, [_vm._v("\n      " + _vm._s(error) + "\n    ")]);
    }), 0);
  }), 0) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }